import { render } from "./MessageList.vue?vue&type=template&id=6f17bfd2&ts=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f17bfd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f17bfd2', __exports__)) {
    api.reload('6f17bfd2', __exports__)
  }
  
  module.hot.accept("./MessageList.vue?vue&type=template&id=6f17bfd2&ts=true", () => {
    api.rerender('6f17bfd2', render)
  })

}


export default __exports__